import Hls from 'hls.js';

/**
 * Initialize a HLS video
 */
export function initHlsVideo() {
	const video = document.querySelector('#section-hero #stream-video');

	if (!video) {
		return;
	}

	if (Hls.isSupported()) {
		const hls = new Hls();
		const hlsUrl = video.dataset.stream;

		hls.loadSource(hlsUrl);
		hls.attachMedia(video);
		hls.on(Hls.Events.MANIFEST_PARSED, () => {
			console.log('HLS manifest geladen, video klaar om te spelen');

			video.play(); // Optioneel: autoplay
		});
	} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
		video.src = hlsUrl;
		video.addEventListener('loadedmetadata', () => {
		console.log('Native HLS geladen, video klaar om te spelen');
			video.play(); // Optioneel: autoplay
		});
	} else {
		console.error('HLS niet ondersteund in deze browser');
	}
}
